app.filter('percent', function() {
    return function(percent) {
        return Math.round(percent * 100) + ' %';
    };
});
